import { jwtDecode } from "jwt-decode";
import { ROLE, PERMISSIONS, PERMISSION } from "./permission.config";

interface User {
  id: number | null;
  email: string;
  firstName: string;
  lastName: string;
  exp: number;
  roles: Role[];
}

interface Role {
  id: number;
  value: string;
  description: string;
}

export class Auth {
  static user: User | null = null;

  static songbookOwner: User | null = null;

  static getToken(): string | null {
    const lsItem = localStorage.getItem("Token");
    if (lsItem) {
      return lsItem;
    }
    return null;
  }

  static getUser(): User | null {
    const lsItem = localStorage.getItem("User");
    if (lsItem) {
      return JSON.parse(lsItem);
    }
    return null;
  }

  // static getSongbookOwner(): User | null {
  //   const lsItem = localStorage.getItem("SongbookOwner");
  //   if (lsItem) {
  //     return JSON.parse(lsItem);
  //   }
  //   return null;
  // }

  static setUserAndToken(token: string): void {
    localStorage.setItem("Token", token);
    const decodedToken: User = jwtDecode(token);
    localStorage.setItem("User", JSON.stringify(decodedToken));
    Auth.user = decodedToken;
  }

  static get isAdminUser(): boolean {
    const user = Auth.getUser();
    if (user) {
      return (user.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "ADMIN";
      });
    }
    return false;
  }

  static get isUser(): boolean {
    const user = Auth.getUser();
    if (user) {
      return (user.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "USER";
      });
    }
    return false;
  }

  static get isSinglePaid(): boolean {
    const user = Auth.getUser();
    if (user) {
      return (user.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "SINGLE_PAID_USER";
      });
    }
    return false;
  }

  static get isBookOwnerAdmin(): boolean {
    if (Auth.songbookOwner) {
      return (Auth.songbookOwner.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "ADMIN";
      });
    }
    return false;
  }

  static get isBookOwnerUser(): boolean {
    if (Auth.songbookOwner) {
      return (Auth.songbookOwner.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "USER";
      });
    }
    return false;
  }

  static get isBookOwnerSinglePaid(): boolean {
    if (Auth.songbookOwner) {
      return (Auth.songbookOwner.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "SINGLE_PAID_USER";
      });
    }
    return false;
  }
  static get isBookOwnerTeamPaid(): boolean {
    if (Auth.songbookOwner) {
      return (Auth.songbookOwner.roles || []).some((role: Role) => {
        return role.value.toUpperCase() === "TEAM_PAID_USER";
      });
    }
    return false;
  }

  static get isAuthenticated(): boolean {
    const token = Auth.getToken();
    if (!token) {
      //localStorage.clear();
      localStorage.removeItem("User");
      localStorage.removeItem("Token");
      return false;
    }
    const user: User = jwtDecode(token);
    if (!user || !user.exp) {
      //localStorage.clear();
      localStorage.removeItem("User");
      localStorage.removeItem("Token");
      return false;
    }
    const expiredDate = new Date(user.exp * 1000);
    const result = expiredDate > new Date();
    return result;
  }

  static setUserLogedOut() {
    //localStorage.clear();
    localStorage.removeItem("User");
    localStorage.removeItem("Token");
  }

  static getPermissionByName(permissionName: string): boolean {
    const permissions: PERMISSION[] = Auth.getPermissions();
    return permissions.includes(permissionName as PERMISSION);
  }

  static getPermissions(): PERMISSION[] {
    let permissions: PERMISSION[] = [];
    const user = Auth.user;
    user?.roles.forEach(({ id, value }: Role) => {
      const key = <ROLE>value.toUpperCase();
      permissions = [...permissions, ...PERMISSIONS[key]];
    });
    return [...new Set(permissions)];
  }
}
